import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useMarket } from "../../context/MarketDhanContext";
import { useMarketIndicators } from "../../context/MarketIndicatorContext";
import HeatMap from "../HeatMap/HeatMap";
import "./Nifty.css";

// import {loadNifty50} from "../../context/SecurityMasterContext";
export default function Nifty() {
  const nifty50 = [
    "TITAN",
    "WIPRO",
    "HCLTECH",
    "INFY",
    "JIOFIN",
    "TECHM",
    "TCS",
    "APOLLOHOSP",
    "BAJAJ-AUTO",
    "SUNPHARMA",
    "COALINDIA",
    "ICICIBANK",
    "JSWSTEEL",
    "EICHERMOT",
    "BEL",
    "ADANIENT",
    "ETERNAL",
    "TRENT",
    "LT",
    "TATACONSUM",
    "AXISBANK",
    "KOTAKBANK",
    "ULTRACEMCO",
    "NESTLEIND",
    "RELIANCE",
    "ITC",
    "NTPC",
    "HINDALCO",
    "ADANIPORTS",
    "BAJAJFINSV",
    "SHRIRAMFIN",
    "HDFCLIFE",
    "BAJFINANCE",
    "BHARTIARTL",
    "HINDUNILVR",
    "M&M",
    "GRASIM",
    "INDIGO",
    "ONGC",
    "SBIN",
    "DRREDDY",
    "SBILIFE",
    "TATASTEEL",
    "HDFCBANK",
    "ASIANPAINT",
    "MAXHEALTH",
    "TMPV",
    "POWERGRID",
    "MARUTI",
    "CIPLA",
  ];
  const [stocksWithNSE, setStocksWithNSE] = useState({});
  const {
    marketData,
    loadNifty50Market,
    loadNifty100Market,
    loading,
    ltpData,
    loadMarketBySymbols,
    initIndex,
    nseData,
  } = useMarket();

  const {
    getMarketCapForSymbols,
    marketCapBulkData,
    loadNifty50PrevClose,
    prevCloseData,
  } = useMarketIndicators();

  const [stocksWithoutNSE, setStocksWithoutNSE] = useState([]);
  // const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState([]);
  const [niftyIdStocks, setNiftyIdStocks] = useState([]);
  const [lastFetched, setLastFetched] = useState(null);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [limit, setLimit] = useState(0);
  const [liveStock, setLiveStock] = useState({});
  const [intraday, setIntraday] = useState([]);
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;

  console.log("livestockNse", liveStock);

  const formatVolume = (volume) => {
    if (volume == null) return "-";

    const num = Number(volume);
    if (!Number.isFinite(num)) return "-";

    return num.toLocaleString("en-IN");
  };

  const navigate = useNavigate();
  // if (loading) return <p>Loading...</p>;
  useEffect(() => {
    initIndex("nifty50");
    getMarketCapForSymbols(nifty50);
    loadNifty50PrevClose();
  }, []);
  console.log("Market Dta", marketData);

  console.log("Market Cap data", marketCapBulkData);
  console.log("Prev close", prevCloseData);
  const prevCloseMap = Object.fromEntries(
    prevCloseData.map((item) => [item.symbol, item.prev_close])
  );
  const mergedMarketData = marketData.map((item) => ({
    ...item,
    close: prevCloseMap[item.symbol] ?? null,
    pChange: Number(
      ((item?.last_price - prevCloseMap[item?.symbol]) /
        prevCloseMap[item?.symbol]) *
        100
    ).toFixed(2),
  }));
  console.log("MergeeMarket Data", mergedMarketData);
  const pChangeMap = Object.fromEntries(
    mergedMarketData.map((item) => [
      item?.symbol,
      Number(item?.pChange), // ensure number, not string
    ])
  );
  const mergedMarketCapData = marketCapBulkData.map((item) => ({
    ...item,
    percent_change: pChangeMap[item.symbol] ?? null,
  }));
  console.log("Merged Market Cap data", mergedMarketCapData);
  return (
    <div>
      <div className="stock-table-container">
        <h1
          style={{
            fontSize: "1.2rem",
            fontWeight: "800",
            textAlign: "center",
            margin: "1rem",
          }}
        >
          NIFTY 50
        </h1>

        <table className="stock-table">
          <thead>
            <tr>
              <th>Symbol</th>
              <th>Price</th>
              <th>Open</th>
              <th>Close</th>
              <th>% Change</th>
              <th>Low</th>
              <th>High</th>
              <th>Volume</th>
              <th>Recommendation</th>
            </tr>
          </thead>

          <tbody>
            {mergedMarketData?.map((stock) => (
              <tr
                key={stock?.security_id}
                onClick={() => navigate(`/stocktest/${stock?.symbol}`)}
                className="stock-row"
              >
                <td>{stock?.symbol}</td>
                <td>₹{stock?.last_price}</td>
                <td>₹{stock?.open}</td>
                <td>₹{stock?.prev_close}</td>

                <td
                  style={{
                    color: stock?.pChange >= 0 ? "#249966" : "#f87171",
                    fontWeight: "bold",
                  }}
                >
                  {stock?.pChange}%
                </td>
                <td>₹{stock?.low}</td>
                <td>₹{stock?.high}</td>
                <td>{formatVolume(stock?.volume)}</td>
                <td>
                  <button
                    className="rec-btn"
                    onClick={() => navigate(`/stocktest/${stock?.company}`)}
                  >
                    View
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="heat-map-div">
        <h1>HeatMap for NIFTY 50</h1>
        <HeatMap data={mergedMarketCapData} />
      </div>
    </div>
  );
}
